import { useEngagement } from '../../data/queries';
import { MediaTile } from '../media/MediaTile';
import type { MediaRow } from '../../data/dto';

interface Props {
  media: MediaRow;
  babyId: string;
  canDecrypt: boolean;
  decrypt: (bytes: Uint8Array) => Uint8Array;
  onOpen: () => void;
  onUnlock: () => void;
  onDelete?: () => void;
}

/**
 * A gallery thumbnail that surfaces its photo's engagement: a comment badge on
 * the image when it has comments, and the reaction emoji below it. Shares the
 * `qk.engagement(babyId,'media',id)` cache with the lightbox's EngagementBar, so
 * opening the photo reuses what was already fetched here.
 */
export function MediaEngageTile({ media, babyId, ...tileProps }: Props) {
  const eng = useEngagement(babyId, 'media', media.id);
  const commentCount = eng.data?.comments.length ?? 0;
  const reactions = eng.data?.reactions ?? [];

  return (
    <div className="flex flex-col gap-1">
      <MediaTile media={media} commentCount={commentCount} {...tileProps} />
      {reactions.length > 0 && (
        <div className="flex flex-wrap gap-1 px-0.5">
          {reactions.map((r) => (
            <span
              key={r.emoji}
              className="inline-flex items-center gap-0.5 rounded-full bg-grey-soft px-1.5 py-0.5 text-[11px] leading-none"
            >
              <span>{r.emoji}</span>
              {r.count > 1 && <span className="font-semibold tabular-nums text-ink-2">{r.count}</span>}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
